





























































































































import { getCompanyMeasure } from "@/services/api";
import { isEnableAuth } from "@/utils/experiment";
import { getCompanyInfo } from "@/utils/getCompanyInfo";
import { Component, Vue, Prop ,Watch } from "vue-property-decorator";


@Component({})
export default class ABTestDisplayTable extends Vue {
  @Prop()
  tableDetail?:any;

  @Prop()
  chooseState?: boolean;

  tableData:any[] = [];
  chooseResult = '';

  @Watch('chooseResult')
  updateChoose() {
    this.$emit('updateChooseResult', this.chooseResult);
  }

  get enableAuth() {
    return isEnableAuth();
  }

  public columnsMap = {
    'viewCnt': '曝光用户数',
    'signupCnt': '提交用户数',
    'signupRate': '提交转化率',
    'orderRate': '下单转化率',

    'phoneCnt': '收集手机号总量',
    'viewRate': '曝光率',
    'orderCnt': '下单数',

    ...(this.enableAuth ? {
      'loginEmailCnt': '第三方登录收集邮箱总量',
      'loginSignUpCnt': '第三方登录提交用户数'
    } : {}),
  }

  tableColumnsList = this.enableAuth
    ? ['viewCnt', 'loginEmailCnt', 'signupCnt', 'loginSignUpCnt', 'signupRate', 'phoneCnt', 'emailCnt', 'birthdayCnt']
    : ['viewCnt', 'signupCnt', 'signupRate', 'orderRate'];

  @Watch('tableDetail')
  getAbtestData() {
    this.tableData = this.tableDetail?.abFormList || [];
    let hasClose = false;
    for (let i = 0; i < this.tableData.length; i++) {
      const item:any = this.tableData[i];
      if (item.type === null) {
        hasClose = true;
        break;
      }
    }
    // 计算各种率
    for (let i = 0; i < this.tableData.length; i++) {
      const item:any = this.tableData[i];
      const userCnt:number = item.participationCnt;
      const userViewCnt:number = item.viewCnt;
      if (userViewCnt > 0) {
        item.signupRate = item.signupCnt > 0 ? `${((item.signupCnt / userViewCnt) * 100).toFixed(2)}%` : '0';
      } else {
        item.signupRate = '-';
      }
      if (hasClose) {
      if (userCnt > 0) {
        item.orderRate = item.orderCnt > 0 ? `${((item.orderCnt / userCnt) * 100).toFixed(2)}%` : '0';
        item.viewRate = item.viewCnt > 0 ? `${((item.viewCnt / userCnt) * 100).toFixed(2)}%` : '0';
      } else {
        item.orderRate = '-';
        item.viewRate = '-';
      }
      } else {
      if (userViewCnt > 0) {
        item.orderRate = item.orderCnt > 0 ? `${((item.orderCnt / userViewCnt) * 100).toFixed(2)}%` : '0';
      } else {
        item.orderRate = '-';
      }
      if (userCnt > 0) {
        item.viewRate = item.viewCnt > 0 ? `${((item.viewCnt / userCnt) * 100).toFixed(2)}%` : '0';
      } else {
        item.viewRate = '-';
      }
      }
    }
    getCompanyMeasure({
      measureCategory: "FORMABTEST"
    }, true).then((res) => {
      let measures = res.data.data.measures;
      if(measures?.length){
        this.tableColumnsList = measures
      }
    })
  }
  mounted() {
    // this.tableData = JSON.parse(JSON.stringify(this.tableDetail?.items || []));
    // this.tableData = this.tableDetail?.abFormList || [];
    getCompanyMeasure({
      measureCategory: "FORMABTEST"
    }, true).then((res) => {
      let measures = res.data.data.measures;
      if(measures?.length){
        this.tableColumnsList = measures
      }
    })
  }

  displayItem(scope:any) {
    if (scope.row.type == 1) {
      window.open(`/wheel_of_fortune/setting/${scope.row.formId}?abtest=true&abtestid=${this.tableDetail.id}`)
    }else if(scope.row.type == 2){
      window.open(`/wheel_of_fortune/pop/${scope.row.formId}?abtest=true&abtestid=${this.tableDetail.id}`)
    }
  }

}
